module.exports = __webpack_public_path__ + "assets/media/evening.2ab877c7.mp3";